import axios from 'axios';
import { User } from '../store/slices/userSlice';
import { UserRole } from '../types/auth.types';
import { API_CONFIG } from '../config/api';

const API_URL = API_CONFIG.BASE_URL;

// Create axios instance with auth header
const createAuthenticatedAxios = () => {
  const token = localStorage.getItem('token');
  return axios.create({
    baseURL: API_URL,
    headers: {
      'Authorization': token ? `Bearer ${token}` : '',
      'Content-Type': 'application/json',
    },
  });
};

export interface CreateUserRequest {
  email: string;
  firstName: string;
  lastName: string;
  password: string;
  role: UserRole;
  department: string;
}

export interface UpdateUserRequest {
  email?: string;
  firstName?: string;
  lastName?: string;
  role?: UserRole;
  department?: string;
}

export interface ApiUser {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  role: UserRole;
  department: string;
  departmentId: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

// Convert API user to frontend user format
const mapApiUserToUser = (apiUser: ApiUser): User => ({
  id: apiUser.id,
  email: apiUser.email,
  firstName: apiUser.firstName,
  lastName: apiUser.lastName,
  role: apiUser.role,
  department: apiUser.department,
  isActive: apiUser.isActive,
});

export const userService = {
  async getAllUsers(): Promise<User[]> {
    const api = createAuthenticatedAxios();
    const response = await api.get<ApiUser[]>('/users');
    return response.data.map(mapApiUserToUser);
  },

  async getUserById(id: string): Promise<User> {
    const api = createAuthenticatedAxios();
    const response = await api.get<ApiUser>(`/users/${id}`);
    return mapApiUserToUser(response.data);
  },

  async createUser(userData: CreateUserRequest): Promise<User> {
    const api = createAuthenticatedAxios();
    console.log('=== CREATE USER API CALL ===');
    console.log('User data being sent:', userData);
    console.log('Token from localStorage:', localStorage.getItem('token'));
    console.log('API base URL:', API_URL);
    
    try {
      const response = await api.post<ApiUser>('/users', userData);
      console.log('Create user successful:', response.data);
      return mapApiUserToUser(response.data);
    } catch (error: any) {
      console.error('=== CREATE USER ERROR ===');
      console.error('Error:', error);
      console.error('Error response:', error.response);
      console.error('Error status:', error.response?.status);
      console.error('Error data:', error.response?.data);
      console.error('Request config:', error.config);
      throw error;
    }
  },

  async updateUser(id: string, userData: UpdateUserRequest): Promise<User> {
    const api = createAuthenticatedAxios();
    const response = await api.put<ApiUser>(`/users/${id}`, userData);
    return mapApiUserToUser(response.data);
  },

  async deleteUser(id: string): Promise<void> {
    const api = createAuthenticatedAxios();
    await api.delete(`/users/${id}`);
  },

  async toggleUserStatus(id: string): Promise<User> {
    const api = createAuthenticatedAxios();
    const response = await api.patch<ApiUser>(`/users/${id}/toggle-status`);
    return mapApiUserToUser(response.data);
  },
}; 